<ob-master-layout [navigation]="isLandingPage ? [] : navigation">
  <ng-container obHeaderTitle>
    {{ isForModule2 | dynamicAppTitle | translate }}
  </ng-container>


  <ng-template #obHeaderControl>
    @if (!isLandingPage) {
      <div class="ob-control-link help-menu-container">
        <button
          mat-button
          obButton="tertiary"
          [obPopover]="dropdownContent"
          placement="bottom"
          matTooltip="{{ 'i18n.common.helpMenu.tooltip' | translate }}"
          [attr.aria-label]="'i18n.common.helpMenu.tooltip' | translate"
          >
          <mat-icon svgIcon="question" class="ob-icon"></mat-icon>
          <span>{{ "sprint9.common.helpMenu.title" | translate }}</span>
        </button>
        <ng-template #dropdownContent>
          <ob-nav-tree #obNavTree [items]="items" />
          <ul class="ob-nav-tree ob-nav-indent expanded ob-nav-bordered ob-nav-hover logib-help"  role="tree">
            <li class="open" role="presentation" id="nav-helpMenuQuickGuide_m1" >
              <a
                aria-selected="false"
                class="ob-nav-link"
                role="treeitem"
                [href]="getTranslatedHref$('m1.links.quick-guide') | async"
                download
                id="lnkdownloadLogibQuickGuidem1"
                target="_blank"
                rel="noopner"
                >
                <span class="icon-text">
                  <mat-icon svgIcon="file_pdf" class="ob-icon"></mat-icon>
                  {{
                  "m2.sprint4.common.helpMenu.quick-guide-m1" | translate
                }}</span>
              </a>
            </li>
            <li class="open" role="presentation" id="nav-helpMenuQuickGuide_m2">
              <a
                aria-selected="false"
                class="ob-nav-link"
                role="treeitem"
                [href]="getTranslatedHref$('m2.links.quick-guide') | async"
                download
                id="lnkdownloadLogibQuickGuide"
                target="_blank"
                rel="noopner"
                >
                <span class="icon-text">
                  <mat-icon svgIcon="file_pdf" class="ob-icon"></mat-icon>
                  {{
                  "m2.sprint4.common.helpMenu.quick-guide-m2" | translate
                  }}
                </span>
              </a>
            </li>
            <li class="open" role="presentation" id="nav-helpMenuWegleitung_m1">
              <a
                aria-selected="false"
                class="ob-nav-link"
                role="treeitem"
                [href]="getTranslatedHref$('m1.links.instructions') | async"
                download
                id="lnkDownloadLogibInstructionsCompletingDataSheetm1"
                target="_blank"
                rel="noopner"
                >
                <span class="icon-text">
                  <mat-icon svgIcon="file_pdf" class="ob-icon"></mat-icon>
                  {{ "m2.sprint4.common.helpMenu.wegleitung-m1" | translate }}
                </span>
              </a>
            </li>
            <li class="open" role="presentation" id="nav-helpMenuWegleitung_m2">
              <a
                aria-selected="false"
                class="ob-nav-link"
                role="treeitem"
                [href]="getTranslatedHref$('m2.links.instructions') | async"
                download
                id="lnkDownloadLogibInstructionsCompletingDataSheet"
                target="_blank"
                rel="noopner">
                <mat-icon svgIcon="file_pdf" class="ob-icon"></mat-icon>
                {{ "m2.sprint4.common.helpMenu.wegleitung-m2" | translate }}
              </a>
            </li>
            <li class="open" role="presentation" id="nav-lnkFaqModule1">
              <a
                aria-selected="false"
                class="ob-nav-link"
                role="treeitem"
                [href]="'sprint9.common.faq_logib' | translate"
                id="lnkFaqModule1"
                target="_blank" icon="none"
                rel="noopener noreferrer"
                >
                <span class="icon-text">
                  <mat-icon svgIcon="link_external" class="ob-icon"></mat-icon>
                  FAQ
                </span>
              </a>
            </li>
            <li class="open" role="presentation" id="nav-hotlineLogib">
              <a
                class="ob-nav-link"
                role="treeitem" icon="none"
                href="tel:{{ 'sprint9.common.hotline-phone' | translate }}"
                >  <span class="icon-text">
                <mat-icon svgIcon="phone" class="ob-icon"></mat-icon>
                <span class = "mr-5">{{ "sprint9.common.hotline-logib" | translate }} </span>
                <span>{{ "sprint9.common.hotline-phone" | translate }}</span>
              </span>
            </a>
          </li>
          <li class="open" role="presentation" id="nav-helpMenuEmail">
            <a
              class="ob-nav-link" icon="none"
              role="treeitem"
              href="mailto:{{ 'i18n.common.helpMenu.email' | translate }}"
              target="_blank"
              title="Email Helpline"
              >  <span class="icon-text">
              <mat-icon svgIcon="mail" class="ob-icon"></mat-icon>
              <span>{{ "i18n.common.helpMenu.email" | translate }}</span>
            </span>
          </a>
        </li>
      </ul>
    </ng-template>
  </div>
}
</ng-template>
<ng-template #obFooterLink>
  <div>
    <nav>
      &copy;
      <span style="cursor: pointer" (click)="setExpertCockpit()">
        {{ today | date : "yyyy" }}
      </span>
      {{ "i18n.application.organization.name" | translate }}
    </nav>
  </div>
</ng-template>
<ng-container obFooterInfo>
  <nav class="footer-legal-framework">
    @if (kontrollmodus) {
      <span>{{ "m2.sprint6.cockpit.tab.cockpit-kontrolle.active" | translate }}</span>
    }
    @if (kontrollmodus) {
      <span class="pr-3 pl-3">-</span>
    }
    <span class="pr-3">{{ "m2.sprint10.home.release" | translate }}&nbsp;{{ release }}</span>
    <span tabindex="0" class="changelog-link" (click)="showChangelogDialog()"
    (keyup.Space)="showChangelogDialog()" translate>app.footer.changelog</span><mat-icon svgIcon="link_external" class="ob-icon-text" />
    <a href="{{ 'm1-m2.sprint11.home.footer.rechtliches' | translate }}" target="_blank" title="" translate>m2.sprint10.home.rechtliches</a>
  </nav>
</ng-container>

</ob-master-layout>
